import { Typography, Box, Link } from "@mui/material";
import React from "react";


const TexteConsent = () => {

    return (
        <Box className='wrapper-consent'  sx={{ backgroundColor: '#ffffff', color: '#000000', padding: '1em', marginBottom: '1em', borderWidth: '1px', borderStyle: 'solid', borderColor: '#D9D9D9', marginTop: '1em' }}>
            <Box className="container-consent">
                <Box className='container-consent-intro'>
                    <h3 className="serious-title-consent" >Titre de la recherche</h3>
                    <Typography>
                        Comprendre la performance cognitivo-énergétique des occupants dans les bâtiments résidentiels : Une piste prometteuse pour réduire la consommation d'énergie.
                    </Typography>
                    <h3 className="serious-title-consent" >Chercheur principal</h3>
                    <Typography>
                        Professeur Louis Gosselin (Université Laval)
                    </Typography>
                    <h3 className="serious-title-consent" >Contexte du projet</h3>
                    <Typography>
                        Projet de recherche financé par le FRQ
                    </Typography>
                </Box>
                <h3 className="serious-title-consent" >Renseignements sur le projet</h3>
                <Typography>
                    Notre projet de recherche utilise un jeu pour nous aider à comprendre la prise de décisions des occupantes et des occupants dans leur domicile. Les résultats de cette recherche permettront de mieux comprendre les actions des occupantes et occupants et ainsi d’améliorer la modélisation du comportement humain dans les simulations énergétiques des bâtiments. Ultimement, cela aidera à développer des bâtiments consommant moins d’énergie et offrant davantage de confort.
                </Typography>
                <h3 className="serious-title-consent" >Votre participation</h3>
                <Typography>
                    Votre participation consistera à remplir un bref questionnaire sociodémographique, visionner une courte vidéo vous expliquant comment jouer au jeu, puis à jouer une partie d'environ 30 minutes. Bien qu’il soit préférable de jouer la partie en entier, vous êtes libre de choisir de mettre fin à votre participation à tout moment, sans avoir à vous justifier. Si vous décidez de mettre fin à votre participation, vos données seront détruites.
                </Typography>
                <h3 className="serious-title-consent" >Confidentialité</h3>
                <Typography>
                    Les chercheuses et les chercheurs sont tenus d’assurer la confidentialité des personnes participantes. À cet égard, voici les mesures qui seront appliquées dans le cadre de la présente recherche :

                    Durant la recherche :
                    <ul>
                        <li>votre nom sera remplacé par un code pour tout le matériel et les données de la recherche contenant des renseignements personnels;</li>
                        <li>seulement les chercheuses et les chercheurs auront accès à la liste contenant les noms et les codes, elle-même conservée séparément du matériel de la recherche et des données;</li>
                        <li>tout le matériel et les données de la recherche seront conservés sur un serveur sécurisé.</li>
                    </ul>

                    Lors de la diffusion des résultats :
                    <ul>
                        <li>les noms des personnes participantes ne paraîtront dans aucun rapport;</li>
                        <li>les résultats de la recherche seront publiés dans des revues scientifiques, et aucune personne participante ne pourra y être identifiée ;</li>
                        <li>un résumé des résultats de la recherche sera expédié aux personnes participantes qui indiqueront leur intérêt en cochant la case correspondante à la fin du questionnaire.</li>
                    </ul>

                    Après la fin de la recherche :
                    <ul>
                        <li>les données récoltées (les informations sociodémographiques et décisions prises par les personnes participantes et les résultats de simulation du jeu) seront anonymisées de façon irréversible</li>
                        <li>tout autre matériel sera utilisé uniquement dans le cadre de la présente recherche et sera détruit au plus tard en décembre 2030.</li>
                    </ul>

                    Une carte-cadeau de 25$ chez un détaillant de votre choix parmi une sélection vous sera offerte dans les 30 jours suivant la fin de votre partie.
                </Typography>
                <h3 className="serious-title-consent" >Remerciements</h3>
                <Typography>
                    Votre collaboration est précieuse pour nous permettre de réaliser cette étude. C’est pourquoi nous tenons à vous remercier pour le temps et l’attention que vous acceptez d’y consacrer.
                </Typography>
                <h3 className="serious-title-consent" >Renseignements supplémentaires</h3>
                <Typography>
                    Si vous avez des questions, veuillez communiquer avec le professeur Louis Gosselin (<Link href="mailto:Louis.Gosselin@gmc.ulaval.ca">Louis.Gosselin@gmc.ulaval.ca</Link>).
                </Typography>
                <h3 className="serious-title-consent" >Plaintes ou critiques</h3>
                <Typography>
                    Si vous avez des plaintes ou des critiques relatives à votre participation à cette recherche, vous pouvez vous adresser, en toute confidentialité, au bureau de l’Ombudsman de l’Université Laval aux coordonnées suivantes :

                    Pavillon Alphonse-Desjardins, bureau 3320
                    2325, rue de l’Université
                    Université Laval
                    Québec (Québec) G1V 0A6
                    Renseignements - Secrétariat : (418) 656-3081
                    Ligne sans frais : 1-866-323-2271
                    Courriel : <Link href="mailto:info@ombudsman.ulaval.ca">info@ombudsman.ulaval.ca</Link>
                </Typography>
            </Box>
        </Box>            
    );
};


export default TexteConsent;